import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CardsDisplayMode } from '../../enums/cards-display-mode.enum';
import { CardsOrientation } from '../../enums/cards-orientation.enum';
import { CardsSize } from '../../enums/cards-size.enum';
import { CardItem } from '../../models/card-item';
import { CardCategory } from '../../models/card-category';
import { CardSearchField } from '../../models/card-search-field';
import { CardListService } from '../../services/card-list.service';

@Component({
    selector: 'cards-category',
    templateUrl: './cards-category.component.html',
    styleUrls: ['./cards-category.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardsCategoryComponent implements OnInit, OnDestroy, CardCategory {
    @Input() public id: string;
    @Input() public title: string;
    private _color: string;

    @Input() public rank: number = -1;

    @Input() public items: CardItem[] = [];
    @Input() public categorized: boolean = true;

    @Input() public cardsOrientation: CardsOrientation = CardsOrientation.WRAPPED;
    @Input() public cardsMode: CardsDisplayMode = CardsDisplayMode.CARDS;
    @Input() public cardsSize: CardsSize = CardsSize.MEDIUM;
    @Input() public active: boolean = true;

    @Input() public itemClickAction: Function;
    @Input() public itemDblClickAction: Function;

    @Input() public currentItemId: string;
    @Input() public showSubtitle: boolean = true;

    @Input() public oneHasImage: boolean = false;

    constructor(private _cardListService: CardListService) { }

    @Input()
    public get color(): string {
        let curColor: string = this._color;

        if (this.rank >= 0 && (this._color == undefined || this._color == null || this._color == '' || !this._cardListService.hasCategColor(this._color))) {
            curColor = this._cardListService.getCategColor(this.rank);
        }

        return curColor;
    }
    public set color(value: string) {
        this._color = value;
    }

    public ngOnInit() {
    }

    public ngOnDestroy() {
    }

    public setFilter(filterWord: string, filterFields: CardSearchField[]) {
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/components/cards-category/cards-category.component.ts